import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Header } from './components/Header';
import { Story } from './components/Story';
import { ProblemSection } from './components/ProblemSection';
import { DiscoverySection } from './components/DiscoverySection';
import { ScienceSection } from './components/ScienceSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FaqSection } from './components/FaqSection';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
import { HeadScripts } from './components/HeadScripts';
export function App() {
  return <HelmetProvider data-id="element-0">
      <HeadScripts data-id="element-1" />
      <div className="bg-white w-full min-h-screen" data-id="element-2">
        <div className="max-w-3xl mx-auto px-4 py-6" data-id="element-3">
          <Header data-id="element-4" />
          <Story data-id="element-5" />
          <ProblemSection data-id="element-6" />
          <DiscoverySection data-id="element-7" />
          <ScienceSection data-id="element-8" />
          <TestimonialsSection data-id="element-9" />
          <FaqSection data-id="element-10" />
          <CallToAction data-id="element-11" />
          <Footer data-id="element-12" />
        </div>
      </div>
    </HelmetProvider>;
}